import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/person/alumni/$id/_profile/activity/",
)({
  component: () => <ComingSoonCover />,
});
